const kafka_env = {
    url: 'https://{env}kafka-rest.gimme.network/',
};

export default kafka_env;